module.exports = {
    SET_REFRESH: "SET_REFRESH",
    SET_REELS_CONFIG: "SET_REELS_CONFIG",
    SET_CURRENT_SPIN_DATA: "SET_CURRENT_SPIN_DATA",
    RESUME_GAME: "RESUME_GAME",
    RESUME_SPIN: "RESUME_SPIN",
    START_SPIN: "START_SPIN",
    REEL_STOPPED: "REEL_STOPPED",
    SPIN_COMPLETE: "SPIN_COMPLETE",
    START_RESPIN: "START_RESPIN",
    RESPIN_COMPLETE: "RESPIN_COMPLETE",
    SET_RESPIN_SUMMARY: "SET_RESPIN_SUMMARY",

    SET_CURRENT_COMET_WILDS_DATA: "SET_CURRENT_COMET_WILDS_DATA",
    COMET_WILDS_MOVEMENT_COMPLETE: "COMET_WILDS_MOVEMENT_COMPLETE",

    //win sequence
    SET_CURRENT_WIN_DATA: "SET_CURRENT_WIN_DATA",
    SET_CURRENT_WIN_COUNTUP: "SET_CURRENT_WIN_COUNTUP",
    WIN_COUNTUP_COMPLETE: "WIN_COUNTUP_COMPLETE",

    SET_CURRENT_WIN_ITERATION: "SET_CURRENT_WIN_ITERATION",
    WIN_ITERATION_COMPLETE: "WIN_ITERATION_COMPLETE",

    START_COUNTDOWN: "START_COUNTDOWN",
    START_BONUS: "START_BONUS",
    ROCKET_TAKEOFF_COMPLETE: "ROCKET_TAKEOFF_COMPLETE",
    SET_CURRENT_PICKS_DATA: "SET_CURRENT_PICKS_DATA",
    START_PICK_STAGE: "START_PICK_STAGE",
    PICK_ITEM: "PICK_ITEM",
    SET_CURRENT_PICK_RESULT_DATA: "SET_CURRENT_PICK_RESULT_DATA",
    ADD_EMERGENCY_FUEL: "ADD_EMERGENCY_FUEL",
    PICK_STAGE_COMPLETE: "PICK_STAGE_COMPLETE",
    START_FREESPIN: "START_FREESPIN",
    FREESPIN_COMPLETE: "FREESPIN_COMPLETE",
    SET_FREESPIN_SUMMARY: "SET_FREESPIN_SUMMARY",
    FREESPIN_SUMMARY_COMPLETE: "FREESPIN_SUMMARY_COMPLETE",

    SET_JACKPOT: "SET_JACKPOT",

    START_MARS_SEQUENCE: "START_MARS_SEQUENCE",
    PICK_LANDING_ZONE: "PICK_LANDING_ZONE",
    SET_JACKPOT_DRAW: "SET_JACKPOT_DRAW",
    BONUS_COMPLETE: "BONUS_COMPLETE",
    ERROR_CLOSED: "ERROR_CLOSED",
    REVERT_GAME: 'REVERT_GAME',

    //sound stuff
    REEL_STOPPING: "REEL_STOPPING",
    COMET_FLYPAST: "COMET_FLYPAST",

    WIN_COUNTUP_STEP: "WIN_COUNTUP_STEP",
    WIN_COUNTUP_LEVEL: "WIN_COUNTUP_LEVEL"
}

